<p-toast></p-toast>

<section class="card">
    <h2 style="text-align: center;">Informe de canjes de Medicos</h2>
    <p-toolbar styleClass="mb-4 gap-2">
        <ng-template pTemplate="left">
            <button pButton pRipple [label]="'Excel'" icon="pi pi-file-excel" class="p-button-success"
                (click)="exportExcel()"></button>
        </ng-template>
    </p-toolbar>

    <p-table [value]="paginacionCanjesMedicos" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th>Medico</th>
                <th>Puntos generados</th>
                <th>Productos aplicados</th>
                <th>Puntos canjeados</th>
                <th>Canjes generados y pagados</th>
                <th>Saldo</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-canje>
            <tr>
                <td>
                    <a [routerLink]="['/administrador/medico', canje.IdMedico]">{{canje.Nombre | uppercase}}</a>
                </td>
                <td>{{canje.PuntosGenerados}}</td>
                <td>{{canje.CantidadProductosAplicados}}</td>
                <td>{{canje.PuntosCanjeados}}</td>
                <td>{{canje.NumerodeCanjesGeneradosyPagados}}</td>
                <td>{{canje.Saldo}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="6" class="text-center p-4">
                    <div class="flex flex-column align-items-center">
                        <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                        <span class="text-600 mt-2">Sin canjes</span>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <div class="flex justify-content-center mt-3">
        <p-paginator (onPageChange)="onPageChange($event)" [first]="currentPage.first" [rows]="currentPage.rows"
            [totalRecords]="totalItems"></p-paginator>
    </div>
</section>
